export interface ITechRawData {
  asTaxes: false
  codeEnum: string
  id: number
  isDeclinable: boolean
  isRequired: boolean
  label: string
  name: string
  category: string
  options: ICaratechFieldOption[]
  type: CaratechType
}

export interface ITechField extends ITechRawData {
  concatSeparator: string
  dimensions: string[3]
  error?: string
  isConcat: boolean
  lock: "lock" | "unlock"
  value: string
}

export interface ICaratechFieldOption {
  code: string
  id: number
  label: string
  name: string
  rankDisplay: number
  cle: string
}

export enum CaratechType {
  text = "text",
  select = "select",
  bool = "bool",
  date = "date",
  number = "number",
}

export default ITechField
